import axios from 'axios';
import APIS from '../../apis';

import  {callbackHandler} from '../callbackHandler';

export default {
    state: {},
    mutations: {},
    getters: {},
    actions: {
        GIFT_BUY(context, {params}){
            return axios.get(APIS.gift_buy, {
                params
            }).then(res => {
                callbackHandler(APIS.gift_buy, res);
                return res.data;
            })
        },
        GIFT_MINE_GIVE(context, {params}){
            return axios.get(APIS.gift_mine_give, {
                params
            }).then(res => {
                callbackHandler(APIS.gift_mine_give, res);
                return res.data;
            })
        },
        GIFT_MINE_RECEIVE(context, {params}){
            return axios.get(APIS.gift_mine_receive, {
                params
            }).then(res => {
                callbackHandler(APIS.gift_mine_receive, res);
                return res.data;
            })
        },
        GIFT_RECEIVE_DETAIL(context, {params}){
            return axios.get(APIS.gift_receive_detail, {
                params
            }).then(res => {
                callbackHandler(APIS.gift_receive_detail, res);
                return res.data;
            })
        },
        GIFT_GIVE(context, {params}){
            return axios.get(APIS.gift_give, {
                params
            }).then(res => {
                callbackHandler(APIS.gift_give, res);
                return res.data;
            })
        },
        GIFT_RECEIVE(context, {params}){
            return axios.get(APIS.gift_receive, {
                params
            }).then(res => {
                callbackHandler(APIS.gift_receive_detail, res);
                return res.data;
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/gift.js